import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const Header = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: column;
  gap: 0px;
  overflow-x: auto;

  /* border-bottom: 1px solid ${colors.secondary.lightGray3}; */
`;

export const HeaderContent = styled.div`
  background: linear-gradient(to bottom, ${colors.primary.white}, ${colors.secondary.lightGray1});
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  border-bottom: 1px solid ${colors.secondary.lightGray3};
  padding: 40px;
`;
